/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostRecruitmentCheckPhoneMutationRequest,
  PostRecruitmentCheckPhoneMutationResponse,
  PostRecruitmentCheckPhone400,
} from '../entities/PostRecruitmentCheckPhone'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostRecruitmentCheckPhoneUrl() {
  return `/recruitment/check-phone` as const
}

/**
 * @description Проверка номера телефона
 * @summary Проверка номера телефона
 * {@link /recruitment/check-phone}
 */
export async function postRecruitmentCheckPhone(
  data: PostRecruitmentCheckPhoneMutationRequest,
  config: Partial<RequestConfig<PostRecruitmentCheckPhoneMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    PostRecruitmentCheckPhoneMutationResponse,
    ResponseErrorConfig<PostRecruitmentCheckPhone400>,
    PostRecruitmentCheckPhoneMutationRequest
  >({ method: 'POST', url: getPostRecruitmentCheckPhoneUrl().toString(), data, ...requestConfig })
  return res.data
}